type FetchError = Error & {
    response?: Response;
};

// from rollbar's typedefs
type Dictionary = { [key: string]: unknown };
type MaybeError = Error | undefined | null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Callback<TResponse = any> = (err: MaybeError, response: TResponse) => void;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LogArgument = string | Error | object | Dictionary | Callback | Date | any[] | undefined;
type LogResult = {
    uuid: string;
};

declare class Rollbar {
    // partial representation, but we don't use more than this

    public log(...args: LogArgument[]): LogResult;

    public info(...args: LogArgument[]): LogResult;

    public warn(...args: LogArgument[]): LogResult;

    public error(...args: LogArgument[]): LogResult;
}

/* eslint-disable no-console */
const Mockbar: Rollbar = {
    info(...args) {
        console.info("[ROLLBAR INFO]", args);
        return { uuid: "mock" };
    },
    log(...args) {
        console.log("[ROLLBAR LOG]", args);
        return { uuid: "mock" };
    },
    warn(...args) {
        console.warn("[ROLLBAR LOG]", args);
        return { uuid: "mock" };
    },
    error(...args) {
        console.error("[ROLLBAR ERROR]", args);
        return { uuid: "mock" };
    },
};
/* eslint-enable */

const { Rollbar: rollbar = Mockbar } = window as { Rollbar?: Rollbar };

export default rollbar;

export function rollbarXHRError(msg: string, e: FetchError, data: object = {}) {
    rollbar.error(msg, e, {
        fingerprint: msg,
        statusCode: e.response && e.response.status,
        ...data,
    });
}
